import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { filter, finalize, map, takeUntil } from 'rxjs/operators';
import { Terminal } from 'src/app/models/entities/terminal';
import { TerminalHistory } from 'src/app/models/entities/terminal-history';
import { VTerminalHistory } from 'src/app/models/entities/v-terminal-history';
import { CustomerTerminalDetailService } from 'src/app/services/customer-terminal-detail.service';
import { CustomerTerminalMainService } from 'src/app/services/customer-terminal-main.service';
import { TerminalHistoryService } from 'src/app/services/terminal-history.service';
import { TerminalService } from 'src/app/services/terminal.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { formatDate } from '@angular/common';
import { VTerminal } from 'src/app/models/entities/v-terminal';

type AOA = any[][];
@Component({
  selector: 'app-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.css']
})
export class TerminalComponent implements OnInit {

  destroy$ = new Subject<void>();
  displayModal: boolean;
  historyModal: boolean;
  deleteModal: boolean;
  uploadModal: boolean;
  returnTerminalId: number;
  deleteTerminalId: number;
  terminals$: Observable<Terminal[]>;
  histories$: Observable<VTerminalHistory[]>;

  progress: boolean = false;
  importModal: boolean = false;
  value: number = 0;
  importErrorMessage: string = "";
  importError: boolean = false;


  importData: AOA = [[]];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';
  importDataList: VTerminal[] = [];

  exportDatas: any[] = [];
  multiDeleteModal: boolean = false;
  loading: boolean;

  selectedRecords: VTerminal[] = [];


  @ViewChild('dt', { static: false }) dt: any;
  constructor(
    private terminalService: TerminalService,
    // private terminalHistoryService: TerminalHistoryService,
    private customerTerminalDetailService: CustomerTerminalDetailService,
    private customerTerminalMainService: CustomerTerminalMainService,
    private toastrService: ToastrService
  ) {
  }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.loading = true;
    this.selectedRecords = [];
    this.terminals$ = this.terminalService.getList().pipe(map(result => result.data), finalize(() => this.loading = false));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showReturnDialog(terminalId: number) {
    this.displayModal = true;
    this.returnTerminalId = terminalId;
  }


  showDeleteDialog(terminalId: number) {
    this.deleteModal = true;
    this.deleteTerminalId = terminalId;
  }

  showMultiDeleteDialog() {
    if (this.selectedRecords.filter(sr => sr.terminalStatus == false).length > 0)
      this.multiDeleteModal = true;
  }

  showUploadDialog() {
    this.uploadModal = true;
  }

  deleteTerminal() {
    this.deleteModal = false;
    this.terminalService.delete(this.deleteTerminalId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.toastrService.success("Terminal başarılı bir şekilde silindi.", "BAŞARILI");
      this.getList();
    })
  }

  deleteTerminals() {
    this.terminalService.deleteRange(this.selectedRecords.filter(sr => sr.terminalStatus == false)).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.toastrService.success(res.message, "BAŞARILI");
      this.getList();
      this.multiDeleteModal = false;
    })
  }

  returnTerminal() {
    this.displayModal = false;
    this.terminalService.getById(this.returnTerminalId).pipe(takeUntil(this.destroy$)).subscribe(result => {
      let terminal: Terminal = result.data;
      terminal.terminalStatus = false;
      this.terminalService.statusUpdate(terminal).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.customerTerminalDetailService.getByTerminalId(this.returnTerminalId).pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.customerTerminalDetailService.delete(data.data.id).pipe(takeUntil(this.destroy$)).subscribe(() => {
              this.customerTerminalDetailService.getListByMainId(data.data.customerTerminalMainId).pipe(takeUntil(this.destroy$)).subscribe(ctd => {
                if (ctd.data.length == 0) {
                  this.customerTerminalMainService.delete(data.data.customerTerminalMainId).pipe(takeUntil(this.destroy$)).subscribe();
                }
                this.toastrService.success("Terminal Müşteriden Geri Alındı.", "BAŞARILI!");
                this.getList();
              })
            })
          })
      })
    });
  }

 

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.importData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
    };
    reader.readAsBinaryString(target.files[0]);
  }


  chechkImport() {
    this.loadImportDatas();
  }

  loadImportDatas() {
    for (let index = 1; index < this.importData.length; index++) {
      const element = this.importData[index];
      let data: VTerminal = new VTerminal;
      data.terminalId = element[0];
      data.deviceModelName = element[1];
      data.imei = element[2];
      data.portalName = element[3];
      this.importDataList.push(data);
    }
    if (this.importDataList.length != 0) {
      this.saveTerminals();
    }
  }


  saveTerminals() {
    this.uploadModal = false;
    this.importModal = true;
    this.save();
  }

  save() {
    this.progress = true;
    let interval = setInterval(() => {
      this.value = this.value + Math.floor(Math.random() * 10) + 1;
      if (this.value >= 100) {
        this.value = 99;
      }
    }, 2000);

    this.terminalService.importTerminal(this.importDataList).pipe(takeUntil(this.destroy$)).subscribe(result => {
      clearInterval(interval);
      this.progress = false;
      this.value = 0;
      this.importError = false;
      this.importModal = false;
      this.importDataList = [];
      this.toastrService.success("Terminaller oluşturuldu", "BAŞARILI!");
      this.getList();
    },
      er => {
        clearInterval(interval);
        this.progress = false;
        this.value = 0;
        this.importModal = false;
        this.importError = true;
        this.importErrorMessage = "";
        this.importErrorMessage = er.error.message;
        this.importDataList = [];
      }
    );

  }


  exportExcel() {

    this.terminalService.getList().pipe(takeUntil(this.destroy$)).subscribe(result => {
      for (let index = 0; index < result.data.length; index++) {
        const element = result.data[index];
        this.exportDatas.push(
          {
            "Platform Adı": element.portalName,
            "Terminal Id": element.terminalId,
            "Imei": element.imei,
            "Cihaz Modeli": element.deviceModelName,
            "Durumu": element.terminalStatusName,
            "Müşteri Kodu": element.customerCode,
            "Müşteri Adı": element.customerName,
            "Proje Adı": element.projectName
          }
        )
      }
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.exportDatas);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Terminal Listesi");
      });
    })


  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + ' ' + formatDate(new Date, 'dd-MM-yyyy', 'en') + EXCEL_EXTENSION);
  }

  exportExcelExample() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet([], { header: ["TerminalId", "Cihaz Modeli", "Imei", "Portal Adı"] });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Aktarım Şablon");
    });
  }



}
